import { sharedConfig } from '@/pageConfig/shared';
import ogImage from '@/static/assets/faq/fr/og-en.png';
import { Faq } from 'contentlayer/generated';
import content from '../../../../.contentlayer/generated/Faq/faq__fr-FR.mdx.json';
import type { BasePageConfig } from '../../BasePageConfig';

type FaqItem = { question: string; answer: string };
const faqItems = (content as unknown as { faqItems: FaqItem[] }).faqItems || [];

const faqSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: faqItems.map((item: FaqItem) => ({
    '@type': 'Question',
    name: item.question,
    acceptedAnswer: {
      '@type': 'Answer',
      text: item.answer,
    },
  })),
};

export type Config = BasePageConfig;

export const config: Config = {
  layout: { ...sharedConfig['fr-FR'].layout },
  seo: {
    title: 'Assurance Multirisques Habitation FAQ | Lemonade à partir de 4 €/mois',
    metaTitle: 'Assurance Multirisques Habitation FAQ | Lemonade à partir de 4 €/mois',
    description:
      "Vous trouverez les réponses aux questions les plus fréquentes - de ce qu'est l'assurance responsabilité civile à ce que couvre votre assurance habitation.",
    jsonld: [faqSchema],
    ogImage: ogImage.src,
  },
  MDXContent: content as Faq,
};
